export function stopRemovableOnTour(
  tour: {
    status?: string;
    is_archived?: boolean;
    stops?: Array<{ pos_id: string; status: string }>;
  },
  posId?: string | null
): boolean {
  if (!posId || tour.status === 'completed' || tour.is_archived) return false;
  const stop = (tour.stops || []).find((row) => row.pos_id === posId);
  return stop?.status === 'pending' || stop?.status === 'skipped';
}
